import { Box } from "@mui/material";
import { Canvas } from "@react-three/fiber";
import { useViewport } from "../../../helpers";
import {
  Environment,
  OrbitControls,
  PerspectiveCamera,
} from "@react-three/drei";
import { Suspense, useEffect } from "react";
import ThreeDimensionsConfiguratorScene from "./ThreeDimensionsConfiguratorScene";
import useThreeJsLoader from "../../../zustand/stores/useThreeJsLoader";
import LoadingScreen from "./LoadingScreen";

const ThreeDimensionsConfigurator = () => {
  const { width } = useViewport();

  const setCanvasReady = useThreeJsLoader((state) => state.setCanvasReady);
  const setSceneIsLoaded = useThreeJsLoader((state) => state.setSceneIsLoaded);

  useEffect(() => {
    return () => {
      setCanvasReady(false);
      setSceneIsLoaded(false);
    };
  }, [setCanvasReady, setSceneIsLoaded]);

  return (
    <Box
      sx={{
        padding: "0 60px",
        paddingBottom: "60px",
        position: "relative",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Canvas
        // flat
        style={{
          width: "95%",
          height: width >= 768 ? (width <= 844 ? "370px" : "680px") : "280px",
          zIndex: "1",
          marginBottom: "340px",
        }}
        onCreated={() => {
          setCanvasReady();
        }}
      >
        <PerspectiveCamera
          position={[-2, 6, 7]} //Calculer la position en fonction du "spawn" de la grille
          makeDefault
          near={0.1}
          far={50}
        />
        <OrbitControls makeDefault={false} target={[0, 0, 0]} />
        <Environment background preset="city" blur={0.8} />
        <Suspense fallback={null}>
          <ThreeDimensionsConfiguratorScene />
        </Suspense>
      </Canvas>
      <LoadingScreen />
    </Box>
  );
};

export default ThreeDimensionsConfigurator;
